import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Startinfo = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 창업안내`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/startUp">아소비 창업</a>
              </li>
              <li>
                <a href="/startInfo" className="sel">
                  창업 안내
                </a>
              </li>
              <li>
                <a href="/startProcess">창업 절차</a>
              </li>
              <li>
                <a href="/benefit">지원 혜택</a>
              </li>
              <li>
                <a href="/asobimanager">아소비 지사장</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title"> 아소비 창업</div>
          <div className="text">
            꾸준히 늘어나는 가맹으로 증명하는 아소비 창업! <br />
            아소비에 대해 알아보고 당신도 성공하는 창업자가 되어 보세요.{" "}
          </div>
          <div className="image">
            <img src="../custom-resources/img/sub_startup_bg.png" alt="" />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">아소비 창업</span>
            </div>
            <div className="menu">
              <a href="/startInfo" className="on">
                창업 안내
              </a>
              <a href="/startProcess">창업 절차</a>
              <a href="/benefit">지원 혜택</a>
              <a href="/asobimanager">아소비 지사장</a>
            </div>
          </div>
        </div>
        <div className="startinfo">
          <div className="sect startinfo01">
            <div className="tit init">
              <span>
                <p>아소비 창업이 좋은 7가지 이유!</p>
              </span>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="txt init">
                  <span>
                    아소비 창업이 좋은 이유. <strong>하나</strong>
                  </span>
                  <strong>특화된 교육 콘텐츠</strong>
                  <p>
                    유쾌, 상쾌, 통쾌한 교육, 아이를 품는 교육을 지향하는
                    아소비는 <br />
                    유치, 초등 저학년(1, 2학년)에 특화된 교육 콘텐츠를 통해{" "}
                    <br />
                    아동이 입회하는 순간부터 차별화된 커리큘럼으로 세심한 케어를
                    제공합니다.
                  </p>
                </div>
                <div className="img">
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img01.png"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img01_after.png"
                    className="animg"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="txt init">
                  <span>
                    아소비 창업이 좋은 이유. <strong>둘</strong>
                  </span>
                  <strong>일과 삶의 균형 있는 조화</strong>
                  <p>
                    아소비는{" "}
                    <span>
                      월요일부터 목요일까지 주 4회, 일 평균 4 ~ 5시간 운영
                    </span>
                    되고 있습니다. <br />
                    수업 시간 외에는 취미생활이나 자기개발을 위한 시간으로
                    충분히 활용할 수 있습니다.
                  </p>
                </div>
                <div className="img">
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img02.gif"
                    className="pc-view"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img02_mo.gif"
                    className="mo-view"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="txt init">
                  <span>
                    아소비 창업이 좋은 이유. <strong>셋</strong>
                  </span>
                  <strong>합리적인 초기 투자 비용</strong>
                  <p>
                    초기 투자 비용은{" "}
                    <span>
                      교육비, 영업권, 제반행정비, 홍보물품, 운영물품 등을 모두
                      포함한 최소의 비용
                    </span>
                    이며,
                    <br /> 가맹 이후 수수료는 0원으로 가맹본사에 제공하는 별도
                    비용은 없습니다.
                    <br /> 319만원으로 특화된 사업을 시작할 수 있는 강력한
                    플랫폼을 가질 수 있습니다. <br />
                  </p>
                </div>
                <div className="img">
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img03.gif"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="txt init">
                  <span>
                    아소비 창업이 좋은 이유. <strong>넷</strong>
                  </span>
                  <strong>높은 수익률 보장</strong>
                  <p>
                    아소비는 교육원 매출 또는 이익에 대한 로열티가 없습니다.{" "}
                    <br />
                    회원 1명당 교육원 수익은 타 프랜차이즈에 비교하여 높은
                    수준입니다.
                  </p>
                </div>
                <div className="img">
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img04.png"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img04_after.png"
                    className="animg init"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="txt">
                  <span>
                    아소비 창업이 좋은 이유. <strong>다섯</strong>
                  </span>
                  <strong>영업 지역권의 보장</strong>
                  <p>
                    아소비 교육원은 배타적이고 독점적인 영업 지역을
                    보장받습니다. <br />
                    영업 지역권 내에서는 본사의 직영점 또는 타 가맹점을 개설할
                    수 없습니다.
                  </p>
                </div>
                <div className="img init">
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img05.gif"
                    className="pc-view"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img05_mo.png"
                    className="mo-view"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="txt init">
                  <span>
                    아소비 창업이 좋은 이유. <strong>여섯</strong>
                  </span>
                  <strong>체계적인 교육 시스템</strong>
                  <p>
                    가맹 교육(본사 및 지사교육), 신규교사 참관수업, 지역 모임,
                    정기 교육, 보수 교육 등 <br />
                    체계적인 교사 교육 시스템을 갖추고 있어 교육 전문가로서
                    자격을 유지할 수 있도록 지원합니다.
                  </p>
                </div>
                <div className="img">
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img06_after4.gif"
                    className="pc-view"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img06_mo.png"
                    className="mo-view"
                    alt=""
                  />
                  {/* < <img src="../custom-resources/img/img_startinfo_startinfo01_img06.png" className="init">
                            <img src="../custom-resources/img/img_startinfo_startinfo01_img06_after.png" className="animg init">
                            <img src="../custom-resources/img/img_startinfo_startinfo01_img06_after2.png" className="animg init">
                            <img src="../custom-resources/img/img_startinfo_startinfo01_img06_after3.png" className="animg init">
                            <img src="../custom-resources/img/img_startinfo_startinfo01_img06_after4.png" className="animg init"> */}
                </div>
              </div>
            </div>
            <div className="desc">
              <div className="wrap">
                <div className="txt init">
                  <span>
                    아소비 창업이 좋은 이유. <strong>일곱</strong>
                  </span>
                  <strong>다양한 혜택과 함께하는 행복한 이벤트</strong>
                  <p>
                    우수 교육원 시상 및 선임 교사 / 수석 교사제 시행을 통해{" "}
                    <br />
                    교사의 열정을 고취시키고 교사에 대한 적절한 대우 및 보상을
                    드립니다. <br />
                    또한 매년 다양한 카페 이벤트, 지역 모임, 분기 시상, 단합대회
                    등을 통해 <br />
                    네트워크를 강화하고 함께하는 즐거움을 느끼실 수 있습니다.
                  </p>
                </div>
                <div className="img">
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img07.png"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo01_img07_after.png"
                    className="animg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sect startinfo02">
            <div className="wrap">
              <div className="tit init">
                당신도 아소비 원장님이 될 수 있습니다.
              </div>
              <div className="txt init">
                아소비는 아이를 사랑하고 교육에 대한 열정을 가지고 있는 모든
                분에게 열려있습니다.
              </div>
              <div className="img init">
                <p>+ 우대 조건 +</p>
                <i>
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo02_img.png"
                    className="init"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo02_img_after.png"
                    className="init animg"
                    alt=""
                  />
                  <img
                    src="../custom-resources/img/img_startinfo_startinfo02_img_after2.png"
                    className="init animg"
                    alt=""
                  />
                </i>
              </div>
            </div>
          </div>
          <div className="sect startinfo03">
            <div className="wrap">
              <div className="tit init">
                '공부방 창업'은 브랜드의 완성도를 보고 하셔야 합니다. <br />
                지금 바로 아소비 선생님에 도전해보세요!
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Startinfo;
